import { B2_URL } from 'constants/Environment';
import { OPPORTUNITIES, COMPANIES, CONTACTS, AGENDA, TASKS, ACTIVITIES } from 'constants/Entities';
import { getDetailRoute } from 'utils/fm';
import IntegrationUtils from './IntegrationUtils';

const redirectUrl = `${B2_URL}/SalesforceAuth.ashx`;
// const idclient = 'forcemanager';
const idclient = `3MVG9HxRZv05HarSWJ0R0Ds8pvZfkZs1.WZwGY2w2sJFkJ.NNHhT1u8siAs8l3jY1Oty2kikUCdKJwCf5IVW.`;

class SalesforceUtils {
    getSalesforceUrl(iduser, implementation) {
        const impldata = `{"UserId":${iduser},"UserImplementation":${implementation}}`;
        const url = `https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id=${idclient}&redirect_uri=${redirectUrl}&state=${IntegrationUtils._encode64(
            impldata,
        )}`;
        return url;
    }

    getEntityUrl(entityId, entity) {
        let url = '';
        switch (entity.toLowerCase()) {
            case 'account':
                url = getDetailRoute({ entity: COMPANIES, id: entityId });
                break;
            case 'contact':
                url = getDetailRoute({ entity: CONTACTS, id: entityId });
                break;
            case 'opportunity':
                url = getDetailRoute({ entity: OPPORTUNITIES, id: entityId });
                break;
            case 'task':
                url = getDetailRoute({ entity: TASKS, id: entityId });
                break;
            case 'event':
                url = getDetailRoute({ entity: AGENDA, id: entityId });
                break;
            case 'activity':
                url = getDetailRoute({ entity: ACTIVITIES, id: entityId });
                break;
        }
        return url;
    }
}

const StoreSingleton = (function () {
    let instance;

    function createInstance() {
        const object = new SalesforceUtils();
        return object;
    }

    return {
        getInstance() {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        },
    };
})();

export default StoreSingleton.getInstance();
